var map = {
	"./block-angry.jpg": "9fd5",
	"./block-excited.jpg": "8abe",
	"./block-happy.jpg": "51c5",
	"./block-love.jpg": "d2fe",
	"./block-meh.jpg": "a9d1",
	"./block-surprise.jpg": "3881",
	"./block-woah.jpg": "69e6",
	"./capacitor-angry.jpg": "c71f7",
	"./capacitor-excited.jpg": "d831",
	"./capacitor-happy.jpg": "a137",
	"./capacitor-love.jpg": "616a",
	"./capacitor-meh.jpg": "5b0e",
	"./capacitor-surprise.jpg": "a073",
	"./capacitor-woah.jpg": "dd7f",
	"./ceramic-angry.jpg": "d812",
	"./ceramic-excited.jpg": "03e2",
	"./ceramic-happy.jpg": "b698",
	"./ceramic-love.jpg": "1a98",
	"./ceramic-meh.jpg": "0947",
	"./ceramic-surprise.jpg": "a991",
	"./ceramic-woah.jpg": "f5af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbe1";